import {ProformaCartLabels} from '@interface/proforma-cart-labels';

class ProformaLabelsClass implements ProformaCartLabels {
  readonly addTo = 'AGGIUNGI_PROFORMA';
  readonly addNewTo = 'AGGIUNGI_NUOVO_PROFORMA';
  readonly label = 'PROFORMA';
  readonly delete = 'ELIMINA_PROFORMA';
  readonly deleteDesc = 'ELIMINA_PROFORMA_DESC';
  readonly detail = 'DETTAGLIO_PROFORMA';
  readonly configurationsAdded = 'CONFIGURAZIONI_PROFORMA';
  readonly search = 'CERCA_PROFORMA';
  readonly emptyList = 'NO_PROFORMA';
  readonly close = 'CHIUDI_PROFORMA';
  readonly recomputePrice = 'NECESSARIO_RICALCOLARE_PREZZO';
}

export const ProformaLabels = new ProformaLabelsClass();
